import React from "react";
import HeaderHome from "../headers/headerHome";
import Footer from "../components/Footer";

export default function PrivacyPolicy() {
  return (
    <>
      <HeaderHome />
      <div className="container py-5">

        <h1 className="mb-4">Politique de confidentialité</h1>

        <section className="mb-4">
          <h3>Données personnelles</h3>
          <p>
            Pour adhérer à l’association, les visiteurs doivent renseigner certaines informations personnelles :
          </p>
          <ul>
            <li>Nom</li>
            <li>Prénom</li>
            <li>Au moins une méthode de contact : adresse e-mail ou numéro de téléphone</li>
          </ul>
          <p>
            Ces informations sont **créées et renseignées par l’administrateur** de l’association. 
            Les utilisateurs n’ont pas la possibilité de modifier ces données depuis le site.
            Elles sont utilisées uniquement pour la gestion des adhésions, l’organisation des événements et la communication interne de l’association.
          </p>
        </section>

        <section className="mb-4">
          <h3>Finalité et utilisation</h3>
          <p>
            Les données collectées sont utilisées exclusivement dans le cadre de l’activité associative :
          </p>
          <ul>
            <li>Gestion administrative des membres</li>
            <li>Organisation et communication autour des événements</li>
            <li>Envoi d’informations importantes aux membres si nécessaire</li>
          </ul>
          <p>
            Aucune donnée personnelle n’est utilisée à des fins commerciales ou partagée avec des tiers.
          </p>
        </section>

        <section className="mb-4">
          <h3>Données statistiques anonymes</h3>
          <p>
            Le site collecte également des informations **anonymes** pour mesurer la fréquentation :
          </p>
          <ul>
            <li>Un identifiant aléatoire généré automatiquement (UUID)</li>
            <li>Date de première et dernière visite</li>
          </ul>
          <p>
            Ces données sont strictement utilisées à des fins statistiques. 
            Aucune adresse IP, donnée de navigation détaillée ou comportementale n’est enregistrée.
          </p>
        </section>

        <section className="mb-4">
          <h3>Sécurité des données</h3>
          <p>
            L’association met en œuvre des mesures techniques et organisationnelles pour garantir la sécurité et la confidentialité des données personnelles et statistiques.
            L’accès aux données personnelles est limité aux membres habilités de l’association.
          </p>
        </section>

        <section className="mb-4">
          <h3>Durée de conservation</h3>
          <p>
            - Les données personnelles des membres sont conservées tant que l’utilisateur est adhérent. <br />
            - Les données statistiques anonymes sont conservées pour une durée maximale de 13 mois.
          </p>
        </section>

        <section className="mb-4">
          <h3>Droits des utilisateurs</h3>
          <p>
            Conformément au RGPD, chaque membre dispose des droits suivants :
          </p>
          <ul>
            <li>Droit d’accès à ses données personnelles</li>
            <li>Droit de rectification ou de mise à jour</li>
            <li>Droit à l’effacement de ses données</li>
            <li>Droit à la limitation du traitement</li>
            <li>Droit d’opposition au traitement de ses données</li>
          </ul>
          <p>
            Ces droits s’exercent en contactant l’administrateur de l’association :
            <br />
            <a href="mailto:mfc1.bournazel@orange.fr" className="mb-0">✉️ mfc1.bournazel@orange.fr</a>
          </p>
        </section>

        <section className="mb-4">
          <h3>Cookies et technologies similaires</h3>
          <p>
            Le site n’utilise pas de cookies publicitaires ni de suivi comportemental. 
            Seuls des identifiants anonymes à usage statistique sont utilisés pour mesurer la fréquentation.
          </p>
        </section>

        <section className="mb-4">
          <h3>Modifications de la politique</h3>
          <p>
            Cette politique peut être mise à jour périodiquement afin de rester conforme à la législation et aux pratiques de l’association.
            Toute modification sera publiée sur cette page.
          </p>
        </section>

      </div>
      <Footer />
    </>
  );
}
